export default __webpack_public_path__ + "static/media/Sydney.6ce83413.jpg";